export default __webpack_public_path__ + "img/inscription-homepage.56eeec78.svg";